import Route from '@ember/routing/route';

export default class CommunityNoticesRoute extends Route {}
